const CM_PER_INCH = 2.54;

class SizeChart extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    // Measurements are authored in cm. Keep the original on the cell so repeated
    // toggling always converts from the source value instead of a rounded one.
    this.cells = Array.from(this.querySelectorAll('tbody td'));
    this.cells.forEach((cell) => {
      cell.dataset.cm = cell.textContent.trim();
    });

    this.buttons = Array.from(this.querySelectorAll('[data-unit]'));
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setUnit(button.dataset.unit));
    });

    this.setUnit(this.dataset.defaultUnit === 'in' ? 'in' : 'cm');
  }

  setUnit(unit) {
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
    });

    this.cells.forEach((cell) => {
      cell.textContent = unit === 'in' ? SizeChart.toInches(cell.dataset.cm) : cell.dataset.cm;
    });
  }

  // Converts every number in the string and leaves everything else alone, so
  // ranges ("77-83") convert to ranges and words ("One Size") pass through.
  static toInches(value) {
    return value.replace(/\d+(\.\d+)?/g, (number) => {
      return String(Math.round((parseFloat(number) / CM_PER_INCH) * 10) / 10);
    });
  }
}

customElements.define('size-chart', SizeChart);
